import * as React from "react";
import {ValuableItemWithStartDate, Image, OnlineRentersClaimRequest, IClaimProperties, ValuableItemCoverLocation} from "@falcon/services";
import {ClaimItemModal} from "./ClaimItemModal";
import ClaimImageUploadPanel from "./ClaimImageUploadPanel";
import {getAmountWithDecimalDigits} from "../../../../../CommonFunctions";
import {ConfirmModal} from "@falcon/plugin-falcon-journey";

interface IProps {
    item: ValuableItemWithStartDate
    onItemUpdate: (item: IClaimProperties) => void;
    onImagesAdding: (itemId: string, images: Image[]) => void;
    onImageRemoving: (itemId: string, imageId: string) => void;
    onValuableItemRemoving: (itemId: string) => void;
    onlineRentersClaimRequest: OnlineRentersClaimRequest;
}

interface IState {
    showItemModal: boolean
    showRemoveConfirmation: boolean
}

export default class ValuableItemClaimPanel extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            showItemModal: false,
            showRemoveConfirmation: false
        };
    }

    public render() {
        return (
            <>
                {this.renderItemPanel()}
                {this.state.showItemModal &&
                <ClaimItemModal
                    showModal={this.state.showItemModal}
                    item={this.props.item}
                    onHide={() => this.setState({showItemModal: false})}
                    onUpdate={this.props.onItemUpdate}
                />}
                {this.state.showRemoveConfirmation &&
                <ConfirmModal show={this.state.showRemoveConfirmation}
                              onHide={() => this.setState({showRemoveConfirmation: false})}
                              confirmButtonText="Yes, please"
                              onConfirm={this.handleValuableItemRemoving}>
                    <div className="fs-20 font-weight-bold font-family-display">
                        Are you sure you want to remove this item?
                    </div>
                </ConfirmModal>}
            </>
        );
    }

    private renderItemPanel = (): JSX.Element => {
        const {item} = this.props;

        return (
            <div className={`mt-2 p-3 bg-white-blue rounded mb-3 valuables-page`}>
                <div>{item.description}</div>
                {item.value && item.value > 0 && <div><b>{item.coverLocation === ValuableItemCoverLocation.ANYWHERE ?  "Cover inside and outside the home" : "Cover inside the home"}</b> for <b>£{item.value}</b></div>}
                {item.premium && item.premium > 0 && <div>Monthly price: <b>{getAmountWithDecimalDigits(item.premium)}</b></div>}
                <ClaimImageUploadPanel
                    item={item}
                    onImagesAdding={this.props.onImagesAdding}
                    onImageRemoving={this.props.onImageRemoving}
                    onlineRentersClaimRequest={this.props.onlineRentersClaimRequest}/>
                {!this.props.item.premium &&
                <div className="d-flex justify-content-between mt-2 font-weight-medium text-blue-1 text-decoration-underline">
                    <span id={`edit-item-${item.valuableItemId}`} onClick={() => this.setState({showItemModal: true})} className="mr-5 cursor-pointer">
                        Edit
                    </span>
                    <span id={`remove-item-${item.valuableItemId}`} onClick={() => this.setState({showRemoveConfirmation: true})} className="cursor-pointer">
                        Remove
                    </span>
                </div>}
            </div>
        )
    };

    private handleValuableItemRemoving = (): void => {
        this.props.onValuableItemRemoving(this.props.item.valuableItemId);
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/subscription/renters/rentersClaims/ValuableItemClaimPanel.tsx